import { AppRoutes } from './router/routes'

export function App() {
  return <AppRoutes />
}
